export enum Weight {
    IMPORTANT = 'IMPORTANT',
    CRITICAL = 'CRITICAL',
    DESIRABLE = 'DESIRABLE',
    IGNORED = 'IGNORED'
}